export default __webpack_public_path__ + "static/log-f06ff90074ee8762ec247f7dc1f734a8.png";